// import React, { useState, useEffect, useRef } from "react";
// import Layout from '../../components/layout/Layout';
// import { useNavigate } from "react-router-dom";
// import { getData } from "../../services/apiService";
// import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import BookOnlineIcon from "@mui/icons-material/BookOnline";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import SchoolIcon from "@mui/icons-material/School";
// import VideocamIcon from "@mui/icons-material/Videocam";
// import { Box, Button, Card, CardContent, Chip, Divider, Grid, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const [upcomingExpanded, setUpcomingExpanded] = useState(false);
//   const [completedClasses, setCompletedClasses] = useState(false);
//   const [courseMenuAnchorEl, setCourseMenuAnchorEl] = useState(null);
//   const [enrolledCourses, setEnrolledCourses] = useState([]);
//   const [upcomingClasses, setUpcomingClasses] = useState([]);
//   const [completedClassData, setCompletedClassData] = useState([]);
//   const [completionRate, setCompletionRate] = useState(0);
//   const [completedLessons, setcompletedLessons] = useState(0);
//   const [completedQuizzes, setCompletedQuizzes] = useState(0);
//   const [refreshKey, setRefreshKey] = useState(0);
//   const isFetched = useRef(false);



//   const handleCourseMenuOpen = (event) => setCourseMenuAnchorEl(event.currentTarget);
//   const handleCourseMenuClose = () => setCourseMenuAnchorEl(null);

//   useEffect(() => {
//     if (!isFetched.current) {
//       fetchData();
//       completedAndUpcomingLessons()
//       isFetched.current = true;
//     }
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await getData("/get-student-dashboard-data");
//       if (response) {
//         setEnrolledCourses(response.enrolledCourses);
//         setCompletionRate(response.percentage);
//         setcompletedLessons(response.completedLessons);
//         setCompletedQuizzes(response.completedQuizzes);
//       }
//     } catch (error) {
//       console.error("Failed to fetch data", error);
//     }
//   };

//   const metricCards = [
//     {
//       title: "Course Completion Rate",
//       value: completionRate + '%',
//       color: "#4B49AC",
//       icon: <BarChartIcon />,
//     },
//     {
//       title: "Total Enrolled Courses",
//       value: enrolledCourses,
//       color: "#52C93F",
//       icon: <SchoolIcon />,
//     },
//     {
//       title: "Courses Completed Lessons",
//       value: completedLessons,
//       color: "#2196F3",
//       icon: <BookOnlineIcon />,
//     },
//     {
//       title: "Courses Completed Quizzes",
//       value: completedQuizzes,
//       color: "#FF7043",
//       icon: <ScheduleIcon />,
//     },
//   ];

//   const EndCourseCompensation = ({
//     percent = completionRate,
//     label = "Course completion",
//   }) => {
//     return (
//       <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//         <Box
//           sx={{
//             width: { xs: 100, sm: 120, md: 140 },
//             height: { xs: 100, sm: 120, md: 140 },
//             borderRadius: "50%",
//             position: "relative",
//             background: `conic-gradient(#4B49AC ${percent * 3.6}deg, #e0e0e0 0deg)`,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//           aria-label={`${label} ${percent}`}
//           role="img"
//         >
//           <Box
//             sx={{
//               width: { xs: 70, sm: 80, md: 96 },
//               height: { xs: 70, sm: 80, md: 96 },
//               borderRadius: "50%",
//               backgroundColor: "white",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.06)",
//             }}
//           >
//             <Typography variant="h5" sx={{ fontWeight: 700, fontSize: "15px" }}>
//               {percent}%
//             </Typography>
//           </Box>
//         </Box>
//         <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontSize: { xs: "0.75rem", md: "0.875rem" } }}>
//           {label}
//         </Typography>
//       </Box>
//     );
//   };

//   //====================================
//   const assessmentResult = ({
//     percent = completionRate,
//     label = "Course completion",
//   }) => {
//     return (
//       <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//         <Box
//           sx={{
//             width: { xs: 100, sm: 120, md: 140 },
//             height: { xs: 100, sm: 120, md: 140 },
//             borderRadius: "50%",
//             position: "relative",
//             background: `conic-gradient(#4B49AC ${percent * 3.6}deg, #e0e0e0 0deg)`,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//           aria-label={`${label} ${percent}`}
//           role="img"
//         >
//           <Box
//             sx={{
//               width: { xs: 70, sm: 80, md: 96 },
//               height: { xs: 70, sm: 80, md: 96 },
//               borderRadius: "50%",
//               backgroundColor: "white",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.06)",
//             }}
//           >
//             <Typography variant="h5" sx={{ fontWeight: 700, fontSize: "15px" }}>
//               {percent}%
//             </Typography>
//           </Box>
//         </Box>
//         <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontSize: { xs: "0.75rem", md: "0.875rem" } }}>
//           {label}
//         </Typography>
//       </Box>
//     );
//   };


//   const completedAndUpcomingLessons = async () => {
//     try {
//       const response = await getData("/completed-and-upcoming-lessons");
//       if (response) {
//         setUpcomingClasses(response.upcomingLessons);
//         setCompletedClassData(response.completedLessons);
//       }
//     } catch (error) {
//       console.error("Failed to fetch data", error);
//     }
//   };

//   const handleRefresh = () => {
//     fetchData();
//     completedAndUpcomingLessons();
//     setRefreshKey((prev) => prev + 1);
//     handleCourseMenuClose();
//   };

//   return (
//     <Layout>
//       <div className="p-6 bg-gray-100 min-h-screen">
//         {/* Metric cards */}
//         <Grid container spacing={{ xs: 2, md: 3 }}>
//           {metricCards.map((card, index) => (
//             <Grid key={index} size={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
//               <Card sx={{ height: "100%", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", border: "none", borderRadius: 2, }} >
//                 <CardContent sx={{ p: { xs: 2, md: 3 } }}>
//                   <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
//                     <Box>
//                       <Typography variant="body2" color="text.secondary" gutterBottom
//                         sx={{ fontSize: { xs: "0.8rem", md: "0.9rem" }, fontWeight: 500 }}
//                       >
//                         {card.title}
//                       </Typography>
//                       <Typography component="div" sx={{ fontSize: { xs: "1.2rem", md: "24px" }, fontWeight: 700, mb: 1 }}>
//                         {card.value}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" } }}>
//                         {card.subtitle}
//                       </Typography>
//                     </Box>
//                     <Box
//                       sx={{
//                         backgroundColor: card.color, borderRadius: 1, p: { xs: 1, md: 1.5 }, color: "white",
//                         display: "flex", alignItems: "center", justifyContent: "center",
//                       }} >
//                       {card.icon}
//                     </Box>
//                   </Stack>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>

//         <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mt: { xs: 2, md: 2 } }}>
//           {/* Upcoming Classes */}
//           <Grid size={{ xs: 12, md: 6 }}>
//             <Card
//               sx={{
//                 boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
//                 border: "none",
//                 borderRadius: 2,
//               }}
//             >
//               <CardContent sx={{ p: { xs: 2, md: 3 } }}>
//                 <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
//                   <Stack direction="row" alignItems="center" spacing={1}>
//                     <ScheduleIcon color="primary" />
//                     <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: "1rem", md: "1.25rem" } }}>
//                       Upcoming Classes
//                     </Typography>
//                   </Stack>
//                   <Button
//                     variant="text"
//                     size="small"
//                     sx={{ fontWeight: 500, color: "#4B49AC", fontSize: { xs: "0.75rem", md: "0.875rem" } }}
//                     onClick={() => setUpcomingExpanded((p) => !p)}
//                   >
//                     {upcomingExpanded ? "View Less" : "View All"}
//                   </Button>
//                 </Stack>

//                 <Stack spacing={2}>
//                   {(upcomingExpanded ? upcomingClasses : upcomingClasses.slice(0, 2)).map(
//                     (classItem, index) => (
//                       <Box key={`${classItem.title}-${index}`}>
//                         <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap">
//                           <Box sx={{ flexGrow: 1, minWidth: { xs: "150px" } }}>
//                             <Typography variant="body1" sx={{ fontWeight: 500, mb: 0.5, fontSize: { xs: "0.875rem", md: "1rem" } }}>
//                               {classItem.title}
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", md: "0.85rem" } }}>
//                               {classItem.duration} mins
//                             </Typography>
//                           </Box>
//                           {index === 0 ? (
//                             <Button variant="contained" size="small"
//                               startIcon={<VideocamIcon />}
//                               onClick={() => navigate("/my-courses")}
//                               sx={{ borderRadius: 1, px: { xs: 1, md: 2 }, mt: { xs: 1, md: 0 }, width: { xs: "100%", md: "auto" }, }} >
//                               Join Class
//                             </Button>
//                           ) : (
//                             <Button variant="outlined" size="small" disabled
//                               sx={{ borderRadius: 1, px: { xs: 1, md: 2 }, mt: { xs: 1, md: 0 }, width: { xs: "100%", md: "auto" }, }} >
//                               Scheduled
//                             </Button>
//                           )}
//                         </Stack>
//                         {index <
//                           (upcomingExpanded ? upcomingClasses.length : Math.min(2, upcomingClasses.length)) -
//                           1 && <Divider sx={{ mt: 2 }} />}
//                       </Box>
//                     )
//                   )}
//                 </Stack>
//               </CardContent>
//             </Card>
//           </Grid>

//           {/* completedClassData */}
//           <Grid size={{ xs: 12, md: 6 }}>
//             <Card sx={{ boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", border: "none", borderRadius: 2, }} >
//               <CardContent sx={{ p: { xs: 2, md: 3 } }}>
//                 <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
//                   <Stack direction="row" alignItems="center" spacing={1}>
//                     <AssignmentTurnedInIcon color="primary" />
//                     <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: "1rem", md: "1.25rem" } }}>
//                       Completed Classes
//                     </Typography>
//                   </Stack>
//                   <Button variant="text" size="small"
//                     sx={{ fontWeight: 500, color: "#4B49AC", fontSize: { xs: "0.75rem", md: "0.875rem" } }}
//                     onClick={() => setCompletedClasses((p) => !p)}
//                   >
//                     {completedClasses ? "View Less" : "View All"}
//                   </Button>
//                 </Stack>

//                 <Stack spacing={2}>
//                   {(completedClasses ? completedClassData : completedClassData.slice(0, 2)).map(
//                     (completedClass, index) => (
//                       <Box key={`${completedClass.title}-${index}`}>
//                         <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap">
//                           <Box sx={{ flexGrow: 1, minWidth: { xs: "150px" } }}>
//                             <Typography variant="body1" sx={{ fontWeight: 500, mb: 0.5, fontSize: { xs: "0.875rem", md: "1rem" } }}>
//                               {completedClass.title}
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", md: "0.85rem" } }}>
//                               {completedClass.duration} mins
//                             </Typography>
//                           </Box>
//                           <Chip label="Completed" size="small" variant="outlined"
//                             sx={{
//                               color: "#4CAF50", backgroundColor: "transparent", borderColor: "rgba(0,0,0,0.12)",
//                               borderRadius: 1, px: { xs: 0.5, md: 1 }, mt: { xs: 1, md: 0 }, width: { xs: "100%", md: "auto" },
//                               "& .MuiChip-label": { fontWeight: 600, fontSize: { xs: "0.75rem", md: "0.875rem" } },
//                             }}
//                           />
//                         </Stack>
//                         {index <
//                           (completedClasses ? completedClassData.length : Math.min(2, completedClassData.length)) - 1 && (
//                             <Divider sx={{ mt: 2 }} />
//                           )}
//                       </Box>
//                     )
//                   )}
//                 </Stack>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>

//         {/* Performance Overview */}
//         <Card sx={{ mt: { xs: 2, md: 3 }, boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", border: "none", borderRadius: 2, }} >
//           <CardContent sx={{ p: { xs: 2, md: 3 } }}>
//             <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
//               <BarChartIcon color="primary" />
//               <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: "1rem", md: "1.25rem" } }}>
//                 Performance Overview
//               </Typography>
//             </Stack>
//             <Typography variant="body2" color="text.secondary" sx={{ mb: { xs: 2, md: 3 }, fontSize: { xs: "0.75rem", md: "0.85rem" } }}>
//               Summary of course completion, feedback, and top performers.
//             </Typography>

//             <Grid container spacing={{ xs: 2, md: 3 }}>
//               <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ display: "flex" }}>
//                 <Box
//                   sx={{
//                     border: 1, borderColor: "grey.300", borderRadius: 2, p: { xs: 1.5, md: 2 },
//                     bgcolor: "background.paper", display: "flex", flexDirection: "column", height: "100%", width: "100%",
//                   }} >
//                   <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
//                     <Typography variant="subtitle1" sx={{ fontWeight: 500, fontSize: { xs: "0.875rem", md: "1rem" } }}>
//                       Course Completion
//                     </Typography>
//                     <IconButton aria-label="course completion menu" onClick={handleCourseMenuOpen} size="small" >
//                       <MoreVertIcon />
//                     </IconButton>
//                   </Stack>
//                   <Menu anchorEl={courseMenuAnchorEl} open={Boolean(courseMenuAnchorEl)} onClose={handleCourseMenuClose} >
//                     <MenuItem onClick={handleRefresh}>Refresh</MenuItem>
//                   </Menu>

//                   <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
//                     <EndCourseCompensation key={refreshKey} percent={completionRate} label="End course compensation" />
//                   </Box>

//                   <Stack direction="row" spacing={{ xs: 1, md: 2 }} alignItems="center" sx={{ mt: "auto", justifyContent: "center" }} >
//                     <Stack direction="row" alignItems="center" spacing={0.5}>
//                       <CheckCircleIcon sx={{ color: "#4B49AC", fontSize: { xs: 14, md: 16 } }} />
//                       <Typography variant="caption" sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" } }}>
//                         Completed
//                       </Typography>
//                     </Stack>
//                     <Stack direction="row" alignItems="center" spacing={0.5}>
//                       <ScheduleIcon sx={{ color: "98BDFF", fontSize: { xs: 14, md: 16 } }} />
//                       <Typography variant="caption" sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" } }}>
//                         In Progress
//                       </Typography>
//                     </Stack>
//                   </Stack>
//                 </Box>

//                 <Box
//                   sx={{
//                     border: 1, borderColor: "grey.300", borderRadius: 2, p: { xs: 1.5, md: 2 },
//                     bgcolor: "background.paper", display: "flex", flexDirection: "column", height: "100%", width: "100%",
//                   }} >
//                   <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
//                     <Typography variant="subtitle1" sx={{ fontWeight: 500, fontSize: { xs: "0.875rem", md: "1rem" } }}>
//                       Course Completion
//                     </Typography>
//                     <IconButton aria-label="course completion menu" onClick={handleCourseMenuOpen} size="small" >
//                       <MoreVertIcon />
//                     </IconButton>
//                   </Stack>
//                   <Menu anchorEl={courseMenuAnchorEl} open={Boolean(courseMenuAnchorEl)} onClose={handleCourseMenuClose} >
//                     <MenuItem onClick={handleRefresh}>Refresh</MenuItem>
//                   </Menu>

//                   <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
//                     <assessmentResult key={refreshKey} percent={completionRate} label="End course compensation" />
//                   </Box>

//                   <Stack direction="row" spacing={{ xs: 1, md: 2 }} alignItems="center" sx={{ mt: "auto", justifyContent: "center" }} >
//                     <Stack direction="row" alignItems="center" spacing={0.5}>
//                       <CheckCircleIcon sx={{ color: "#4B49AC", fontSize: { xs: 14, md: 16 } }} />
//                       <Typography variant="caption" sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" } }}>
//                         Completed
//                       </Typography>
//                     </Stack>
//                     <Stack direction="row" alignItems="center" spacing={0.5}>
//                       <ScheduleIcon sx={{ color: "98BDFF", fontSize: { xs: 14, md: 16 } }} />
//                       <Typography variant="caption" sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" } }}>
//                         In Progress
//                       </Typography>
//                     </Stack>
//                   </Stack>
//                 </Box>


//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>

//       </div>
//     </Layout>
//   );
// };

// export default Dashboard;


import React, { useState, useEffect, useRef } from "react";
import Layout from '../../components/layout/Layout';
import { useNavigate } from "react-router-dom";
import { getData } from "../../services/apiService";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import BarChartIcon from "@mui/icons-material/BarChart";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SchoolIcon from "@mui/icons-material/School";
import VideocamIcon from "@mui/icons-material/Videocam";
import { Box, Button, Card, CardContent, Chip, Divider, Grid, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";

const Dashboard = () => {
  const navigate = useNavigate();
  const [upcomingExpanded, setUpcomingExpanded] = useState(false);
  const [completedClasses, setCompletedClasses] = useState(false);
  const [courseMenuAnchorEl, setCourseMenuAnchorEl] = useState(null);
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [upcomingClasses, setUpcomingClasses] = useState([]);
  const [performanceResult, SetperformanceResult] = useState([]);
  const [resultStatus, setResultstatus] = useState([]);
  const [completedClassData, setCompletedClassData] = useState([]);
  const [completionRate, setCompletionRate] = useState(0);
  const [completedLessons, setcompletedLessons] = useState(0);
  const [completedQuizzes, setCompletedQuizzes] = useState(0);
  const [assessmentScore, setAssessmentScore] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const isFetched = useRef(false);

  const handleCourseMenuOpen = (event) => setCourseMenuAnchorEl(event.currentTarget);
  const handleCourseMenuClose = () => setCourseMenuAnchorEl(null);

  useEffect(() => {
    if (!isFetched.current) {
      fetchData();
      completedAndUpcomingLessons();
      getOverallResult();
      isFetched.current = true;
    }
  }, []);

  const fetchData = async () => {
    try {
      const response = await getData("/get-student-dashboard-data");
      if (response) {
        setEnrolledCourses(response.enrolledCourses);
        setCompletionRate(response.percentage);
        setcompletedLessons(response.completedLessons);
        setCompletedQuizzes(response.quizSubmissions);
      }
    } catch (error) {
      console.error("Failed to fetch data", error);
    }
  };
  const getOverallResult = async () => {
    try {
      const response = await getData("/get-overall-result");
      if (response) {
        setAssessmentScore(response.percentage);
        setResultstatus(response.status);
        SetperformanceResult(response.performanceResult);
      }
    } catch (error) {
      console.error("Failed to fetch data", error);
    }
  };

  const metricCards = [
    {
      title: "Course Completion Rate",
      value: completionRate + '%',
      color: "#4B49AC",
      icon: <BarChartIcon />,
    },
    {
      title: "Total Enrolled Courses",
      value: enrolledCourses,
      color: "#52C93F",
      icon: <SchoolIcon />,
    },
    {
      title: "Completed Lessons",
      value: completedLessons,
      color: "#2196F3",
      icon: <BookOnlineIcon />,
    },
    {
      title: "Completed Quizzes",
      value: completedQuizzes,
      color: "#FF7043",
      icon: <ScheduleIcon />,
    },
  ];

  const CircularProgressChart = ({
    percent = 0,
    label = "Progress",
    color = "#4B49AC"
  }) => {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box
          sx={{
            width: { xs: 100, sm: 120, md: 140 },
            height: { xs: 100, sm: 120, md: 140 },
            borderRadius: "50%",
            position: "relative",
            background: `conic-gradient(${color} ${percent * 3.6}deg, #e0e0e0 0deg)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          aria-label={`${label} ${percent}`}
          role="img"
        >
          <Box
            sx={{
              width: { xs: 70, sm: 80, md: 96 },
              height: { xs: 70, sm: 80, md: 96 },
              borderRadius: "50%",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.06)",
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 700, fontSize: "15px" }}>
              {percent}%
            </Typography>
          </Box>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontSize: { xs: "0.75rem", md: "0.875rem" } }}>
          {label}
        </Typography>
      </Box>
    );
  };

  const completedAndUpcomingLessons = async () => {
    try {
      const response = await getData("/completed-and-upcoming-lessons");
      if (response) {
        setUpcomingClasses(response.upcomingLessons);
        setCompletedClassData(response.completedLessons);
      }
    } catch (error) {
      console.error("Failed to fetch data", error);
    }
  };

  const handleRefresh = () => {
    getOverallResult();
    fetchData();
    completedAndUpcomingLessons();
    setRefreshKey((prev) => prev + 1);
    handleCourseMenuClose();
  };

  return (
    <Layout>
      <div className="p-6 bg-gray-100 min-h-screen">
        {/* Metric cards */}
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {metricCards.map((card, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
              <Card sx={{ height: "100%", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", border: "none", borderRadius: 2, }} >
                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                  <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                    <Box>
                      <Typography variant="body2" color="text.secondary" gutterBottom
                        sx={{ fontSize: { xs: "0.8rem", md: "0.9rem" }, fontWeight: 500 }}
                      >
                        {card.title}
                      </Typography>
                      <Typography component="div" sx={{ fontSize: { xs: "1.2rem", md: "24px" }, fontWeight: 700, mb: 1 }}>
                        {card.value}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" } }}>
                        {card.subtitle}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: card.color, borderRadius: 1, p: { xs: 1, md: 1.5 }, color: "white",
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }} >
                      {card.icon}
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mt: { xs: 2, md: 2 } }}>
          {/* Upcoming Classes */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Card
              sx={{
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                border: "none",
                borderRadius: 2,
              }}
            >
              <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <ScheduleIcon color="primary" />
                    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: "1rem", md: "1.25rem" } }}>
                      Upcoming Classes
                    </Typography>
                  </Stack>
                  <Button
                    variant="text"
                    size="small"
                    sx={{ fontWeight: 500, color: "#4B49AC", fontSize: { xs: "0.75rem", md: "0.875rem" } }}
                    onClick={() => setUpcomingExpanded((p) => !p)}
                  >
                    {upcomingExpanded ? "View Less" : "View All"}
                  </Button>
                </Stack>

                {/* <Stack spacing={2}> */}
                <Stack
                  spacing={2}
                  sx={{
                    height: "280px",      // fixed card content height
                    overflowY: "auto",   // scrollbar when more than 3 items
                    pr: 1,

                    // optional scrollbar styling
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#c1c1c1",
                      borderRadius: "10px",
                    },
                  }}
                >
                  {(upcomingExpanded ? upcomingClasses : upcomingClasses.slice(0, 4)).map(
                    (classItem, index) => (
                      <Box key={`${classItem.title}-${index}`}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                          <Box sx={{ flexGrow: 1, minWidth: { xs: "150px" } }}>
                            <Typography variant="body1" sx={{ fontWeight: 500, mb: 0.5, fontSize: { xs: "0.875rem", md: "1rem" } }}>
                              {classItem.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", md: "0.85rem" } }}>
                              {classItem.duration} mins
                            </Typography>
                          </Box>
                          {index === 0 ? (
                            <Button variant="contained" size="small"
                              startIcon={<VideocamIcon />}
                              onClick={() => navigate("/my-courses")}
                              sx={{ borderRadius: 1, px: { xs: 1, md: 2 }, mt: { xs: 1, md: 0 }, width: { xs: "100%", md: "auto" }, }} >
                              Join Class
                            </Button>
                          ) : (
                            <Button variant="outlined" size="small" disabled
                              sx={{ borderRadius: 1, px: { xs: 1, md: 2 }, mt: { xs: 1, md: 0 }, width: { xs: "100%", md: "auto" }, }} >
                              Scheduled
                            </Button>
                          )}
                        </Stack>
                        {index <
                          (upcomingExpanded ? upcomingClasses.length : Math.min(2, upcomingClasses.length)) -
                          1 && <Divider sx={{ mt: 2 }} />}
                      </Box>
                    )
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>

          {/* Completed Classes */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Card sx={{ boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", border: "none", borderRadius: 2, }} >
              <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <AssignmentTurnedInIcon color="primary" />
                    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: "1rem", md: "1.25rem" } }}>
                      Completed Classes
                    </Typography>
                  </Stack>
                  <Button variant="text" size="small"
                    sx={{ fontWeight: 500, color: "#4B49AC", fontSize: { xs: "0.75rem", md: "0.875rem" } }}
                    onClick={() => setCompletedClasses((p) => !p)}
                  >
                    {completedClasses ? "View Less" : "View All"}
                  </Button>
                </Stack>

                {/* <Stack spacing={2}> */}
                <Stack
                  spacing={2}
                  sx={{
                    height: "280px",      // fixed card content height
                    overflowY: "auto",   // scrollbar when more than 3 items
                    pr: 1,

                    // optional scrollbar styling
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#c1c1c1",
                      borderRadius: "10px",
                    },
                  }}
                >
                  {(completedClasses ? completedClassData : completedClassData.slice(0, 4)).map(
                    (completedClass, index) => (
                      <Box key={`${completedClass.title}-${index}`}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                          <Box sx={{ flexGrow: 1, minWidth: { xs: "150px" } }}>
                            <Typography variant="body1" sx={{ fontWeight: 500, mb: 0.5, fontSize: { xs: "0.875rem", md: "1rem" } }}>
                              {completedClass.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: "0.75rem", md: "0.85rem" } }}>
                              {completedClass.duration} mins
                            </Typography>
                          </Box>
                          <Chip label="Completed" size="small" variant="outlined"
                            sx={{
                              color: "#4CAF50", backgroundColor: "transparent", borderColor: "rgba(0,0,0,0.12)",
                              borderRadius: 1, px: { xs: 0.5, md: 1 }, mt: { xs: 1, md: 0 }, width: { xs: "100%", md: "auto" },
                              "& .MuiChip-label": { fontWeight: 600, fontSize: { xs: "0.75rem", md: "0.875rem" } },
                            }}
                          />
                        </Stack>
                        {index <
                          (completedClasses ? completedClassData.length : Math.min(2, completedClassData.length)) - 1 && (
                            <Divider sx={{ mt: 2 }} />
                          )}
                      </Box>
                    )
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Performance Overview */}
        <Card sx={{ mt: { xs: 2, md: 3 }, boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", border: "none", borderRadius: 2, }} >
          <CardContent sx={{ p: { xs: 2, md: 3 } }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
              <BarChartIcon color="primary" />
              <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: "1rem", md: "1.25rem" } }}>
                Performance Overview
              </Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary" sx={{ mb: { xs: 2, md: 3 }, fontSize: { xs: "0.75rem", md: "0.85rem" } }}>
              Summary of course completion, feedback, and top performers.
            </Typography>

            <Grid container spacing={{ xs: 2, md: 3 }}>
              {/* Course Completion */}
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    border: 1, borderColor: "grey.300", borderRadius: 2, p: { xs: 1.5, md: 2 },
                    bgcolor: "background.paper", display: "flex", flexDirection: "column", height: "100%", width: "100%",
                  }} >
                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 500, fontSize: { xs: "0.875rem", md: "1rem" } }}>
                      Course Completion
                    </Typography>
                    <IconButton aria-label="course completion menu" onClick={handleCourseMenuOpen} size="small" >
                      <MoreVertIcon />
                    </IconButton>
                  </Stack>
                  <Menu anchorEl={courseMenuAnchorEl} open={Boolean(courseMenuAnchorEl)} onClose={handleCourseMenuClose} >
                    <MenuItem onClick={handleRefresh}>Refresh</MenuItem>
                  </Menu>

                  <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                    <CircularProgressChart
                      key={refreshKey}
                      // percent={completionRate}
                      percent={Math.round(completionRate)}
                      label="Course completion"
                      color="#4B49AC"
                    />
                  </Box>

                  <Stack direction="row" spacing={{ xs: 1, md: 2 }} alignItems="center" sx={{ mt: "auto", justifyContent: "center" }} >
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <CheckCircleIcon sx={{ color: "#4B49AC", fontSize: { xs: 14, md: 16 } }} />
                      <Typography variant="caption" sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" } }}>
                        Completed
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <ScheduleIcon sx={{ color: "#98BDFF", fontSize: { xs: 14, md: 16 } }} />
                      <Typography variant="caption" sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" } }}>
                        In Progress
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Grid>

              {/* Assessment Results */}
              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    border: 1, borderColor: "grey.300", borderRadius: 2, p: { xs: 1.5, md: 2 },
                    bgcolor: "background.paper", display: "flex", flexDirection: "column", height: "100%", width: "100%",
                  }} >
                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 500, fontSize: { xs: "0.875rem", md: "1rem" } }}>
                      Assessment Results
                    </Typography>
                    <IconButton aria-label="assessment menu" onClick={handleCourseMenuOpen} size="small" >
                      <MoreVertIcon />
                    </IconButton>
                  </Stack>

                  <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                    <CircularProgressChart
                      key={refreshKey}
                      // percent={assessmentScore} 
                      percent={Math.round(assessmentScore)}
                      label="Average score"
                      color="#FF7043"
                    />
                  </Box>

                  <Stack direction="row" spacing={{ xs: 1, md: 2 }} alignItems="center" sx={{ mt: "auto", justifyContent: "center" }} >
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <CheckCircleIcon sx={{ color: "#4CAF50", fontSize: { xs: 14, md: 16 } }} />
                      <Typography variant="caption" sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" } }}>
                        {resultStatus}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <ScheduleIcon sx={{ color: "#F44336", fontSize: { xs: 14, md: 16 } }} />
                      <Typography variant="caption" sx={{ fontSize: { xs: "0.7rem", md: "0.8rem" } }}>
                        {/* Needs Improvement */}
                        {performanceResult}
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default Dashboard;